"use strict";

var _cartTable = _interopRequireDefault(require("../components/cart-table"));

var _freeShipping = _interopRequireDefault(require("../components/free-shipping"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
/**
 * Template: Cart
 * ------------------------------------------------------------------------------
 * Loosely coupled cart page scripts.
 *
 * @namespace cart
 */

/**
 * DOM selectors.
 */


var selectors = {
  container: '[js-cart="container"]',
  table: '[js-cart-table="container"]'
};
/**
 * Global instance strings.
 */

var strings = {
  title: theme.strings.cart.general.title,
  empty: theme.strings.cart.general.empty,
  continueBrowsing: theme.strings.cart.general.continue_browsing
};
document.addEventListener('DOMContentLoaded', function () {
  (0, _cartTable["default"])(selectors.table).init();
  (0, _freeShipping["default"])().init();
  Frame.EventBus.listen('AjaxCart:cartEmpty', function () {
    document.querySelector(selectors.container).innerHTML = "\n      <div class=\"container\">\n        <div class=\"row\">\n          <div class=\"col s12 m6 offset-m3 text-center\">\n            <h1>".concat(strings.title, "</h1>\n            <p>").concat(strings.empty, "</p>\n            <a href=\"/collections/all\" class=\"button button--primary button--large\">").concat(strings.continueBrowsing, "</a>\n          </div>\n        </div>\n      </div>\n    ");
  });
});